export default "__VITE_ASSET__xtae3FnH__"